module.exports = __webpack_public_path__ + "files/SPIADI2019 - Présentation RICAI_backup.b9f3b4dd958eb7f3800662ec3363119e.pdf";